export default "__VITE_ASSET__bUiy4IRT__"